import React, { PropsWithChildren, useState } from 'react'

import * as S from './styles'
import { Text, Image } from '@/components'
import { CasePagination } from '@/components/casePagination'
import { useIsVisibleElement } from '@/hooks'
import { ProjectsContainerProps } from '@/service/api/servicesPage'

export type ProjectContainerProps = PropsWithChildren<{
  data: ProjectsContainerProps[]
}>

export const ProjectsContainer: React.FC<ProjectContainerProps> = ({
  data,
}) => {
  const [projectIndex, setProjectIndex] = useState(0)
  const { element, elementVisible } = useIsVisibleElement()

  if (data.length === 0) return null

  const project = data[projectIndex]
  return (
    <S.ProjectsContainer>
      <div className="container-img" ref={element}>
        <Image
          src={project?.focusImage.url}
          alt={project?.focusImage.alt}
          fileName={project?.focusImage.fileName}
          defaultSize={project?.focusImage.defaultSize}
          responsiveSizes={project?.focusImage.responsiveSizes}
          className={`slide ${elementVisible ? 'active' : ''}`}
        />
      </div>
      <S.ContentContainer>
        <S.ImageContainer
          width={project?.logo.defaultSize.width}
          height={project?.logo.defaultSize.height}
        >
          <Image
            src={project?.logo.url}
            alt={project?.logo.alt}
            fileName={project?.logo.fileName}
            defaultSize={project?.logo.defaultSize}
          />
        </S.ImageContainer>
        <Text size="h4" className="title">
          {project?.title}
        </Text>
        <Text size="b2" className="description">
          {project?.description}
        </Text>
        <CasePagination
          length={data.length}
          index={projectIndex}
          setIndex={setProjectIndex}
          slug={project.slug}
          className="case-pagination"
        />
      </S.ContentContainer>
    </S.ProjectsContainer>
  )
}
